import { AxiosError, AxiosResponse } from 'axios';
import { FetchResult, instance } from './config';
import { useMutation } from '@tanstack/react-query';
import { ILoginRequestBody, ILoginResponse } from '@types';

type LoginErrorResponse = {
  errorMessage: string;
};

async function postLogin(body: ILoginRequestBody): Promise<AxiosResponse<FetchResult<ILoginResponse>>> {
  const response = await instance.post(`/auth/login`, body);
  return response;
}

const usePostLogin = (
  onSuccess?: (data: AxiosResponse<FetchResult<ILoginResponse>>) => void,
  onError?: (err: AxiosError<LoginErrorResponse>) => void
) => {
  const { data, mutate, error, isPending } = useMutation({
    mutationKey: ['post', `/auth/login`],
    mutationFn: (body: ILoginRequestBody) => postLogin(body),
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (err: AxiosError<LoginErrorResponse>) => {
      onError?.(err);
    },
    retry: false
  });

  return { data, mutate, error, isPending };
};

export default usePostLogin;
